var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 108,
    height: 108,
    rx: 10,
    fill: "#CF375D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.182 24.24C54.8085 24.0799 54.4064 23.9973 54 23.9973C53.5936 23.9973 53.1915 24.0799 52.818 24.24L33.636 32.466C32.5569 32.9285 31.6373 33.6975 30.991 34.6776C30.3447 35.6578 30.0001 36.806 30 37.98V58.56C30.0004 62.2617 30.9792 65.8976 32.8374 69.0992C34.6955 72.3008 37.367 74.9544 40.581 76.791L52.512 83.607C52.9652 83.8659 53.4781 84.002 54 84.002C54.5219 84.002 55.0348 83.8659 55.488 83.607L67.419 76.791C70.6339 74.9539 73.3059 72.2994 75.1641 69.0966C77.0223 65.8939 78.0007 62.2568 78 58.554V37.98C77.9999 36.806 77.6553 35.6578 77.009 34.6776C76.3627 33.6975 75.4431 32.9285 74.364 32.466L55.182 24.24Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityIcon);
export default __webpack_public_path__ + "static/media/integrity-icon.4c2dd37bcb882c7038f667d72a7fcb39.svg";
export { ForwardRef as ReactComponent };